import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/content';
import ContentListItem from '@/components/base/ContentListItem';

export default function LatestNews({ items }: { items: ContentItem[] }) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新资讯</h2>
          <p className="mt-1.5 text-sm text-foreground-600">社会、科技、财经热点即时更新</p>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="rounded-lg border border-background-200/70 bg-background-50 px-5 py-2 md:px-6">
        {items.map((item) => (
          <ContentListItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}